import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=060de002&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=060de002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060de002",
  null
  
)

export default component.exports